import React, {Component} from 'react'
import PropTypes from 'prop-types'
import getHistory from '../../../../../helpers/rounting/getHistory'
import {Alert, Button, Modal, Input, notification, Radio, Typography, Select, Divider} from 'antd'
import ErrorList from './errorList/errorList'
import queryString from "query-string"
import {
    createBatchByNumberV3,
    listNumberOrderByBatches,
    listPartner,
    listLevels
} from "../../../../../services/api/3dApi"

const {TextArea} = Input
const {Text} = Typography
const {Option} = Select

class CreateBatchListV2 extends Component {
    state = {
        isOpen: true,
        loading: false,
        loadingBatches: false,
        message: '',
        name: [],
        listBatches: [],
        string: '',
        userCreate: '',
        levels: [],
        level: "1",
        error: '',
        errorBatches: '',
        partner: '',
        partners: [],
        errorPartner: ''
    }

    componentDidMount() {
        const {listBarcodeSelected} = this.props
        this.setState(preState => ({
            ...preState,
            string : listBarcodeSelected.join('\n'),
            name: listBarcodeSelected
        }))
        this._fetchLevel()
        this._fetchPartner()
    }

    _handleChangInutBatches = async e => {
        const {value} = e.target

        const arr = value.split(/,|\r|\n|\t|\r\n|\s|,\s|,/)
        const newArr = arr.filter(item => item !== '')

        this.setState({
            listBatches: newArr
        })
    }

    _handleListItems = async () => {
        const {listBatches} = this.state

        const payload = {
            batches: listBatches
        }

        try {
            this.setState({
                errorBatches: '',
                loadingBatches: true
            })

            const {data: response} = await listNumberOrderByBatches(payload)

            const {success, error, data} = response

            if (!success) {
                return this.setState({
                    errorBatches: error,
                    loadingBatches: false
                })
            }

            const listItems = data.map(item => {
                return `#${item.barcode_number}_${item.item_number}`
            })

            this.setState({
                string: listItems.join(', '),
                name: listItems,
                loadingBatches: false
            })
        } catch (e) {
            this.setState({
                errorBatches: e.message
            })
        }
    }

    _handleChange = e => {
        const {value} = e.target

        this.setState({
            string: value
        }, () => {
            const arr = this.state.string.split(/#|\r|\n|\t|\r\n|\s|,\s|,/)
            const newArr = arr.filter(item => item !== '')

            this.setState({
                name: newArr
            })
        })
    }

    _handleChangeText = (e) => {
        const {value} = e.target

        this.setState({
            userCreate: value.trim()
        })
    }

    _onChangeRadio = (e) => {
        this.setState({
            level: e.target.value
        })
    }

    _onChangeSelect = (value) => {
        this.setState({
            partner: value
        })
    }

    _handleSubmit = async (e) => {
        e.preventDefault()

        this.setState({
            loading: true
        })

        const {name, userCreate, level, partner} = this.state

        if (name.length === 0) {
            this.setState({
                loading: false,
                message: 'Vui lòng nhập vào một mã order'
            })
        } else {
            try {
                const payload = {
                    templates: name,
                    user_create: userCreate,
                    level: level,
                    partner: partner
                }

                const {data: response} = await createBatchByNumberV3(payload)

                const {success, error, data} = response

                if (!success) {
                    throw new Error(error)
                } else {
                    this.setState({
                        loading: false,
                        isOpen: false
                    })

                    const {errorResult} = data
                    const {_id} = data.batch

                    if (errorResult.length > 0) {
                        notification.error({
                            message: 'ERROR',
                            description: <ErrorList list={errorResult}/>,
                            duration: 0,
                        })
                    }

                    if (_id) {
                        const history = getHistory()
                        history.push(`/batches/${_id}`)
                    }
                }
            } catch (error) {
                this.setState({
                    loading: false,
                    message: error.message
                })
            }
        }
    }

    _renderModalFooter = () => {
        const buttonCancel = <Button key='btnCancelBulkAction1' onClick={this._closeModal}
                                     disabled={this.state.loading}>Hủy</Button>
        const buttonOk = <Button loading={this.state.loading} key='btnOKBulkAction1' type='primary'
                                 onClick={this._handleSubmit}
                                 disabled={this.state.loading || !this.state.name.length}>Tạo</Button>

        return [buttonCancel, buttonOk]
    }

    _closeModal = () => {
        this.setState({
            isOpen: false,
        })
    }

    _handleAfterClose = () => {
        this.props.onResetAction()
    }

    _fetchPartner = async () => {
        try {
            const payload = {
                type: 'print_partner'
            }
            const query = queryString.stringify(payload)

            const {data: response} = await listPartner(query)

            const {data, success, error} = response

            if (!success) {
                this.setState({
                    errorPartner: error
                })

                return
            }

            this.setState({
                partners: data.partners
            })
        } catch (e) {
            this.setState({
                errorPartner: e.message
            })
        }
    }

    _fetchLevel = async () => {
        try {
            const {data: response} = await listLevels()

            const {data, success, error} = response

            if (!success) {
                this.setState({
                    error: error
                })

                return
            }

            this.setState({
                levels: data
            })
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    render() {
        const {
            isOpen,
            message,
            name,
            string,
            level,
            error,
            levels,
            errorPartner,
            partner,
            partners,
            errorBatches,
            loadingBatches,
            listBatches
        } = this.state

        const modalFooter = this._renderModalFooter()

        return (
            <Modal
                visible={isOpen}
                title='Tạo Lô'
                className='GenerateTemplateByQuery'
                afterClose={this._handleAfterClose}
                closable={false}
                footer={modalFooter}
            >
                {
                    message && <Alert className="mb-3" message="Lỗi" description={message} type="error"/>
                }
                <div>
                    <div className="mb-2">
                        <label htmlFor='listTemplateIds' className='fs-16'>
                            Nhập tên lô theo từng dòng hoặc cách nhau bằng dấu phẩy:
                        </label>
                        <TextArea rows={6} onChange={this._handleChangInutBatches}
                                  placeholder='B-456'>{string}</TextArea>
                        {errorBatches && <div className="mt-1 text-danger">{errorBatches}</div>}
                        <div className="text-right mt-3">
                            <Button loading={loadingBatches} type='primary'
                                    onClick={this._handleListItems} disabled={loadingBatches || !listBatches.length}>Lấy
                                danh sách items</Button>
                        </div>
                    </div>

                    <Divider/>

                    <div className="mb-2">
                        <label htmlFor='listTemplateIds' className='fs-16'>
                            Nhập templates theo từng dòng hoặc cách nhau bằng dấu phẩy:
                        </label>
                        <TextArea rows={6} onChange={this._handleChange} placeholder='123456_7'
                                  value={string}>{string}</TextArea>
                    </div>

                    <div className='mt-2'>
                        Đã nhập: <span className='font-weight-bold'>{name.length} items</span>
                    </div>

                    <label className="mt-3 font-weight-bold">
                        Người tạo:
                    </label>
                    <Input type="text" placeholder="Nhập tên người tạo"
                           onChange={this._handleChangeText}
                    />

                    <label className='mt-3 d-block font-weight-bold'>
                        Đối tác in/ép:
                    </label>
                    {
                        errorPartner ?
                            <Text type='danger'>{errorPartner}</Text> :
                            <Select onChange={this._onChangeSelect} value={partner} className='customSelect'>
                                <Option value={''}>---Hãy chọn 1 đối tác---</Option>
                                {
                                    partners.length > 0 && partners.map(item => {
                                        return <Option key={item._id} value={item._id}>{item.name}</Option>
                                    })
                                }
                            </Select>
                    }

                    <label className='mt-3 d-block font-weight-bold'>
                        Độ ưu tiên:
                    </label>
                    {
                        error ?
                            <Text type='danger'>{error}</Text> :
                            <Radio.Group onChange={this._onChangeRadio} value={level}>
                                {
                                    levels.length > 0 && levels.map(item => {
                                        return <Radio key={item.key} value={item.key}>{item.value}</Radio>
                                    })
                                }
                            </Radio.Group>
                    }
                </div>
            </Modal>
        )
    }
}

CreateBatchListV2.propTypes = {
    onResetAction: PropTypes.func.isRequired,
    query: PropTypes.object.isRequired
}

export default CreateBatchListV2
